// src/router/empresa/sucursal/ventas.routes.js

//   {
//     path: 'ventas',
//     name: 'empresa.sucursal.ventas',
//     component: () => import('@/views/empresa/sucursal/ventas/VentasSucursalLayout.vue'),
//     children: [
//       {
//         path: '',
//         name: 'empresa.sucursal.ventasListado',
//         component: () => import('@/views/empresa/sucursal/ventas/VentasSucursalListado.vue'),
//       },
//     ],
//   },

export default [
  {
    path: 'ventas', // 👈 Esto hace que sea la ruta por defecto al entrar a la sucursal
    name: 'empresa.sucursal.ventas',
    component: () => import('@/views/empresa/sucursales/ventas/VentaSucursalHome.vue'),
  },
    {
    path: 'ventas/registrar', // 👈 Esto hace que sea la ruta por defecto al entrar a la sucursal
    name: 'empresa.sucursal.ventas.registrar',
    component: () => import('@/views/empresa/sucursales/ventas/VentaSucursalRegistrar.vue'),
  },
  {
    path: 'comprobantes/consultar',
    name: 'empresa.sucursal.comprobantes.consultar',
    redirect: { name: 'empresa.sucursal.comprobantes.consultar.listado' },
    component: () => import('@/components/shared/comprobantes/ComprobanteConsultar.vue'),
    children: [
      {
        path: '',
        name: 'empresa.sucursal.comprobantes.consultar.listado',
        component: () => import('@/views/empresa/sucursales/ventas/ComprobanteConsultarList.vue'),
      },
    ],
  }
  
]
